import React, { useEffect } from "react";

const DummyComponent = () => {
  useEffect(() => {
    console.log("Rendering DummyComponent for ui.table 8");
  }, []);

  return (
    <div style={{ padding: '20px', backgroundColor: 'lightgray', textAlign: 'center' }}>
      <h1>Dummy Component for testing!</h1>
      <p>rendered under ui.table 8.</p>
    </div>
  );
};

export default DummyComponent;
